import { render } from "./MovimentacaoProcessualComponent.vue?vue&type=template&id=95a141b4&scoped=true"
import script from "./MovimentacaoProcessualComponent.vue?vue&type=script&lang=js"
export * from "./MovimentacaoProcessualComponent.vue?vue&type=script&lang=js"

import "./MovimentacaoProcessualComponent.vue?vue&type=style&index=0&id=95a141b4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95a141b4"]])

export default __exports__